<!--  -->
<template>
  <div>
     <div
    
     ref="showimg"
      @click="showimg"
      class="showimg"
    ><img
        src="@/assets/img/zuo343.png"
        alt=""
      ></div>
    <div  class="hezuo"
      ref="hezuoimg">
       <img
        @click="hideimg"
        class="closeopen"
        src="@/assets/img/shanchu44.png"
        alt=""
      >
      <img
        @click="ishezuo = true,istijiao=false"
        class="zuodfr"
        src="@/assets/img/hezuo.png"
        alt=""
      />
    </div>

    <!--  ------------- -----------------------合作弹出框------------------------------------------ -->
    <div
      v-if="ishezuo"
      style="z-index: 999"
    >
      <div class="popup_prompt">
        <div class="prompt_div">
          <img
            @click="ishezuo = false"
            class="esc"
            src="@/assets/img/chacha.png"
            alt=""
          />
          <div class="title">
            <img
              src="@/assets/img/hezuodig.png"
              alt=""
            />
            <span>合作&建议</span>
          </div>
          <div class="text2">
            具体内容请填写以下信息，相关合作我们会与您取得联系
          </div>
          <div class="input1">
            <!-- <span>姓名</span> -->
            <input
              placeholder="姓名"
              v-model="heform.name"
              type="text"
            />
          </div>
          <div class="input1">
            <!-- <span>手机/微信</span> -->
            <input
              placeholder="手机/微信"
              v-model="heform.concat"
              type="text"
            />
          </div>
          <div class="input1">
            <!-- <span>单位名称</span> -->
            <input
              placeholder="单位名称"
              v-model="heform.company"
              type="text"
            />
          </div>
          <!-- <div class="input133">
            <el-radio
              v-model="radio"
              :label="1"
            >合作</el-radio>
            <el-radio
              v-model="radio"
              :label="2"
            >建议</el-radio>
          </div> -->
          <!-- <div
            class="input2 input1"
            style="margin-top:0px"
          >
             <textarea
              v-show="radio===1"
              placeholder="请输入合作内容~"
              v-model="heform.content"
              id=""
              cols="30"
              rows="10"
            ></textarea>
            <textarea
              v-show="radio===2"
              placeholder="请输入您的建议~"
              v-model="heform.status"
              id=""
              cols="30"
              rows="10"
            ></textarea>
          </div> -->
          <div class="inp3q33">
            <el-tabs type="border-card">
              <el-tab-pane label="合作">
                <div
                  class="input2 "
                  style=" margin-top:1vw"
                >
                  <textarea
                    v-model="heform.content"
                    id=""
                    cols="30"
                    rows="10"
                    placeholder="请输入合作内容~"
                  ></textarea>
                </div>
              </el-tab-pane>
              <el-tab-pane label="建议">
                 <div
                  class="input2 "
                  style=" margin-top:1vw"
                >
                  <textarea
                    v-model="heform.status"
                    id=""
                    cols="30"
                    rows="10"
                    placeholder="请输入您的建议~"
                  ></textarea>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div
            @click="tijiaook12"
            class="tijao4"
          >提交</div>
          <div class="qitahe">
            <div>
              <div class="teq1">其他方式</div>
              <div class="teq2">xuzhi@anesthesiavision.cn</div>
            </div>
            <img
              src="@/assets/img/gonhong1.png"
              alt=""
            />
          </div>
          <div class="butok2"></div>
        </div>
      </div>
    </div>
    <!--  ------------------------------------提交成功弹出框------------------------------------------ -->
    <div v-if="istijiao">
      <div class="popup_prompt">
        <div
          class="prompt_div"
          style="height: 495px"
        >
          <img
            @click="istijiao = false"
            class="esc"
            src="@/assets/img/chacha.png"
            alt=""
          />
          <div class="tijiaook">
            <img
              class="tiji1"
              src="@/assets/img/tijiaook.png"
              alt=""
            />
            <div class="tiji2">信息已提交成功</div>
            <div class="tiji3">
              相关合作我们将尽快与您取得联系，请您注意
              微信好友添加信息，保持电话畅通
            </div>
            <img
              class="tiji4"
              src="@/assets/img/thinkyou.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      ishezuo: false,
      //   完成弹出
      istijiao: false,
      radio: 1,
      heform: {
        name: "",
        concat: "",
        company: "",
        content: "",
        type: 1,
        status: '',
        member_id: ''
      },
    };
  },
  methods: {
    // 完成提交弹窗
    tijiaook12 () {
      // if (
      //   this.heform.name.trim() &&
      //   this.heform.concat.trim() &&
      //   this.heform.company.trim() &&
      //   this.heform.content.trim() || this.heform.status.trim()
      // ) {
      //   if (localStorage.getItem('USER_111')) {
      //     this.heform.member_id = JSON.parse(localStorage.getItem('USER_111')).id
      //     this.getpost()
      //   } else {
      //     this.heform.member_id = -1
      //     this.getpost()
      //   }

      // } else {
      //   this.$message.error("请正确填写表单哦~");
      // }
      if(!this.heform.name.trim()){
        this.$message.error("请填写 姓名 哦~");
      }else if(!this.heform.concat.trim()){
        this.$message.error("请填写 手机/微信 哦~");
      }else if(!this.heform.company.trim()){
        this.$message.error("请填写 单位名称 哦~");
      }else if (this.heform.content.trim()===''&&this.heform.status.trim()===''||this.heform.status.trim()===''&&this.heform.content.trim()==='') {
        this.$message.error("请填写 合作/建议 哦~");
      }else{
          if (localStorage.getItem('USER_111')) {
          this.heform.member_id = JSON.parse(localStorage.getItem('USER_111')).id
          this.getpost()
        } else {
          this.heform.member_id = -1
          this.getpost()
        }
      }
    },
    getpost () {
      this.$post("concat", { ...this.heform }).then((res) => {
        if (res.code === 200) {
          this.ishezuo = false;
          this.istijiao = true;
          this.radio = 1
          this.heform = {
            name: "",
            concat: "",
            company: "",
            content: "",
            type: 1,
            status: '',
            menber_id: ''
          }
        } else {
          this.$message.error("提交表单出错啦~");
        }
      });
    },
      hideimg () {
      this.$refs.hezuoimg.style.transform = "translateX(200%)"
      this.$refs.hezuoimg.style.opacity = "0"
      this.$refs.showimg.style.opacity = "1"
    },
    showimg () {
       this.$refs.hezuoimg.style.transform = "translateX(0px)"
      this.$refs.hezuoimg.style.opacity = "1"
      this.$refs.showimg.style.opacity = "0"

     }

  },
};
</script>
<style  scoped>
.hezuo {
  width: 90px;
  position: fixed;
  bottom: 7vw;
  right: 1vw;
  z-index: 99;
  cursor: pointer;
  transition: all 1.5s;
  text-align: right;
}
.hezuo .zuodfr {
  width: 11.07vw;
  object-fit: cover;
}
.showimg {
  cursor: pointer;
    width: 4vw;
    height: 4vw;
    line-height: 4vw;
    position: fixed;
    bottom: 7vw;
    right: -2.6vw;
  z-index: 99;
  background-color: #fd6b6d;
  border-radius: 50%;
  transition: all 1s;
  opacity: 0;
}
.showimg img {
  width: 1.6vw;
}
.closeopen {
  width: 1.5vw;
}
/* 视频分类弹出框 */
.popup_prompt {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9;
}
.prompt_div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  width: 512px;
  height: 820px;
  border-radius: 10px;
  background: #f9f9f9;
}
.prompt_div .esc {
  width: 13.61px;
  height: 13.61px;
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
.prompt_div .title {
  width: 100%;
  display: flex;
  margin-top: 22px;
  justify-content: center;
  align-items: center;
}
.prompt_div .title img {
  width: 67px;
  height: 67px;
  object-fit: cover;
  margin-right: 10px;
}
.prompt_div .title div {
  width: 67px;
  height: 67px;
  object-fit: cover;
}
.prompt_div .title span {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  opacity: 1;
}
.prompt_div .catelist {
  padding: 5.33vw 7.5vw;
  height: 63vw;
  overflow: scroll;
}
.prompt_div .cateitem {
  float: left;
  width: 33.33vw;
  height: 9.07vw;
  background: #ffffff;
  box-shadow: 0vw 1vw 1vw rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 1vw;
  font-size: 3.2vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  text-align: center;
  line-height: 9.07vw;
  margin-bottom: 4.5vw;
}
.activecate1 {
  background: #51a3ff !important;
  color: #fff !important;
}
.prompt_div .cateitem img {
  width: 2.98vw;
  height: 3.01vw;
}
.prompt_div .cateitem:nth-child(2n) {
  margin-left: 5.2vw;
}
.butok2 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 46px;
  border-radius: 0px 0px 4px 4px;
  background: #2a2a2a;
  text-align: center;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 1;
}

/* 合作弹出 */
.text2 {
  width: 439px;
  font-size: 17px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  opacity: 1;
  margin: auto;
  /* text-align: center; */
}
.prompt_div .input1 {
  width: 449px;
  height: 41px;
  line-height: 41px;
  background: #ffffff;
  border: 1px solid #cccccc;
  opacity: 1;
  border-radius: 4px;
  margin: auto;
  margin-top: 12px;
  padding-left: 10px;
}
.input133 {
  margin-top: 10px;
  width: 449px;
  height: 31px;
  padding-left: 27px;
  display: flex;
  font-size: 18px;
  color: #9999;
}
.inp3q33 {
  margin-top: 10px;
  width: 460px;
  padding-left: 27px;
  font-size: 18px;
  color: #9999;
}
.input133 div {
  cursor: pointer;
}
.input133 i {
  margin-right: 4px;
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid rgb(180, 179, 179);
  vertical-align: text-top;
  box-sizing: border-box;
}
.checli {
  background-color: #afafaf !important;
}
.prompt_div .input1 span {
  width: 70px;
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 27px;
  color: #999999;
  opacity: 1;
  padding: 0px 10px;
}
.prompt_div .input1 input {
  width: 97%;
}
.prompt_div .input2 {
  display: flex;
  height: 160px;
  background: #ffffff;
  border: 1px solid #cccccc;
  opacity: 1;
  border-radius: 4px;
  margin: auto;
  margin-top: 15px;
  overflow: hidden;
}
/deep/ .el-tabs--border-card {
  box-shadow: none;
  border-radius: 6px;
  border: 1px solid #cccccc;
  overflow: hidden;

}
.prompt_div .input2 textarea {
  border-radius: 4px;
  width: 100%;
  height: 132px;
  border: 0;
  outline: 0;
  padding: 10px 10px;
}
.prompt_div .input2 textarea::placeholder {
font-size: 16px;
}
.tijao4 {
  cursor: pointer;
  width: 415px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(90deg, #5eb1ff 0%, #0c57fe 100%);
  opacity: 1;
  border-radius: 20px;
  background: linear-gradient(90deg, #5eb1ff 0%, #0c57fe 100%);

  font-size: 18px;
  font-family: AdobeHeitiStd-Regular;
  color: #ffffff;
  opacity: 1;
  text-align: center;
  margin: auto;
  margin-top: 25px;
}
.qitahe {
  width: 449px;
  height: 130px;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  margin-top: 25px;
}
.qitahe div {
  font-family: Source Han Sans CN;
}
.qitahe img {
  width: 129px;
  height: 129px;
  object-fit: cover;
}
.teq1 {
  height: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  margin: auto;
  color: #333333;
  margin-bottom: 20px;
}
.teq2 {
  width: 215px;
  height: 19px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  margin: auto;
  color: #999999;
}
/* 提交成功 */
.tijiaook {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.tiji1 {
  margin-top: 77px;
  width: 63px;
  height: 63px;
  object-fit: cover;
}
.tiji2 {
  margin-top: 25px;
  width: 170px;
  height: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 27px;
  color: #333333;
  opacity: 1;
}
.tiji3 {
  margin-top: 30px;
  width: 290px;
  height: 45px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 27px;
  color: #999999;
  opacity: 1;
}
.tiji4 {
  margin-top: 5px;
  width: 180px;
  height: 180px;
  object-fit: contain;
}
</style>


// WEBPACK FOOTER //
// src/components/tool/hezuo.vue